<template>
  <div class="wxyg-table">
    <div
      class="wxyg-status-message"
      :class="{ 'warning': lx === '0' }"
    >
      <div class="status-message">
        <img
          :src="`/images/newscreen/icon/${lx === '1' ? 'online' : 'Offline'}.png`"
          style="margin-right: 10px;"
        >
        <span class="status-message-text">
          {{ lx === '1' ? '以下无线烟感连接正常，系统运行良好！' : '警告：以下无线烟感当前处于离线状态，请立即检测网络连接和设备状态！' }}
        </span>
      </div>
    </div>

    <!-- 筛选控件 -->
    <div class="filter-container">
      <div class="filter-row">
        <div class="filter-item">
          <label>设备品牌:</label>
          <el-input
            v-model="filters.zjpp"
            placeholder="筛选品牌"
            size="mini"
            clearable
            @input="applyFilters"
          />
        </div>
        <div class="filter-item">
          <label>设备名称:</label>
          <el-input
            v-model="filters.zjmc"
            placeholder="筛选设备名"
            size="mini"
            clearable
            @input="applyFilters"
          />
        </div>
        <div class="filter-item">
          <label>安装位置:</label>
          <el-input
            v-model="filters.azwz"
            placeholder="筛选位置"
            size="mini"
            clearable
            @input="applyFilters"
          />
        </div>
        <div class="filter-item">
          <label>时长排序:</label>
          <el-select
            v-model="sortOrder"
            size="mini"
            placeholder="选择排序"
            @change="applyFilters"
          >
            <el-option label="默认" value="" />
            <el-option label="时长升序" value="asc" />
            <el-option label="时长降序" value="desc" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-button
            size="mini"
            type="primary"
            @click="clearFilters"
          >
            清空筛选
          </el-button>
        </div>
      </div>
    </div>

    <div
      class="table-container"
      :style="{ height: error ? '250px' : '320px'}"
    >
      <el-table
        v-loading="loading"
        :data="paginatedData"
        style="width: 100%; margin-top: 20px;"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        :empty-text="emptyText"
        :span-method="objectSpanMethod"
        element-loading-text="加载中..."
        element-loading-background="rgba(12, 27, 59, 0.8)"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="zjpp"
          label="设备品牌"
          align="center"
        />
        <el-table-column
          prop="zjmc"
          label="设备名称"
          align="center"
        />
        <el-table-column
          prop="azwz"
          label="安装位置"
          align="center"
        />
        <el-table-column
          label="离线时长"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <span :style="{ color: scope.row.zt === '0' ? '#F90101' : '#11F155' }">
              {{ calculateOfflineDuration(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="zt"
          label="连接状态"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="{ 'online': scope.row.zt === '1', 'offline': scope.row.zt === '0', 'unlinked': scope.row.zt === '3' }">
              {{ scope.row.zt === '1' ? '在线' : (scope.row.zt === '0' ? '离线' : '未关联') }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        :total="filteredTableData.length"
        layout="total, sizes, prev, pager, next, jumper"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <div
      v-if="error"
      class="wxyg-status-message warning"
    >
      <div class="status-message">
        <span class="status-message-text">{{ error }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { monitorService } from '../monitor.service';

export default {
  name: 'WxygTable',
  props: {
    lx: {
      type: String,
      required: true
    },
    jzwId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      tableData: [],
      filteredTableData: [], // 筛选后的原始数据
      loading: false,
      error: null,
      emptyText: '暂无数据',
      headerCellStyle: {
        backgroundColor: 'transparent',
        color: '#ffffff',
        fontWeight: 'bold'
      },
      cellStyle: {
        backgroundColor: 'transparent',
        color: '#ffffff'
      },
      spanArr: [], // 用于存储合并信息
      // 分页相关
      currentPage: 1,
      pageSize: 5,
      paginatedSpanArr: [], // 分页后的合并信息
      refreshTimer: null, // 用于定时刷新离线时长
      filters: {
        zjpp: '',
        zjmc: '',
        azwz: ''
      },
      sortOrder: ''
    };
  },
  computed: {
    // 当前页显示的数据
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      const pageData = this.filteredTableData.slice(start, end);

      // 重新计算当前页的合并信息
      this.calculatePaginatedSpanArr(pageData);

      return pageData;
    }
  },
  methods: {
    fetchData () {
      this.loading = true;
      this.error = null;
      monitorService.queryWxygxx()
        .then(response => {
          const allData = response.data || [];

          if (allData && allData.length > 0) {
            // 按照设备品牌排序，确保相同品牌的项目排列在一起
            const sortedData = [...allData].sort((a, b) => {
              return (a.zjpp || '').localeCompare(b.zjpp || '');
            });

            // 筛选在线/离线状态
            let filteredData = sortedData.filter(item => {
              return String(item.zt) === String(this.lx);
            });

            // 如果建筑id不为空，则进一步筛选
            if (this.jzwId && this.jzwId !== '') {
              filteredData = filteredData.filter(item => {
                return String(item.jzid) === String(this.jzwId);
              });
            }

            // 应用用户筛选条件
            if (this.filters.zjpp) {
              filteredData = filteredData.filter(item =>
                item.zjpp && item.zjpp.toLowerCase().includes(this.filters.zjpp.toLowerCase())
              );
            }
            if (this.filters.zjmc) {
              filteredData = filteredData.filter(item =>
                item.zjmc && item.zjmc.toLowerCase().includes(this.filters.zjmc.toLowerCase())
              );
            }
            if (this.filters.azwz) {
              filteredData = filteredData.filter(item =>
                item.azwz && item.azwz.toLowerCase().includes(this.filters.azwz.toLowerCase())
              );
            }

            // 应用排序逻辑
            if (this.sortOrder) {
              filteredData = this.applySorting(filteredData);
            }

            this.filteredTableData = filteredData;
            this.tableData = filteredData;

            // 重置分页到第一页（仅在非筛选场景下）
            if (!this.filters.zjpp && !this.filters.zjmc && !this.filters.azwz && !this.sortOrder) {
              this.currentPage = 1;
            }

            // 如果没有数据，设置相应的提示信息
            if (this.filteredTableData.length === 0) {
              if (this.lx === '1') {
                this.error = '当前没有任何在线的无线烟感';
              } else if (this.lx === '0') {
                this.error = '当前没有离线的无线烟感';
              }
            }
          } else {
            this.filteredTableData = [];
            this.tableData = [];
            this.error = '没有获取到无线烟感信息数据';
          }
        })
        .catch(error => {
          console.error('获取无线烟感信息失败:', error);
          this.error = '获取无线烟感信息失败: ' + (error.message || '未知错误');
          this.$message.error('获取无线烟感信息失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 计算分页后的合并信息
    calculatePaginatedSpanArr (pageData) {
      this.paginatedSpanArr = [];

      if (pageData.length === 0) return;

      let currentBrand = '';
      let count = 0;
      let position = 0;

      pageData.forEach((item, index) => {
        if (index === 0) {
          this.paginatedSpanArr.push(1);
          currentBrand = item.zjpp;
          count = 1;
          position = 0;
        } else if (item.zjpp === currentBrand) {
          this.paginatedSpanArr.push(0);
          count++;

          // 如果是最后一行，更新开始位置的合并行数
          if (index === pageData.length - 1) {
            this.paginatedSpanArr[position] = count;
          }
        } else {
          // 品牌变化，更新前一个品牌的合并行数
          this.paginatedSpanArr[position] = count;
          position = index;
          this.paginatedSpanArr.push(1);
          currentBrand = item.zjpp;
          count = 1;

          // 如果这是最后一行，直接设置为1
          if (index === pageData.length - 1) {
            this.paginatedSpanArr[position] = 1;
          }
        }
      });

      // 确保最后一个品牌组的合并信息正确
      if (position < pageData.length && count > 0) {
        this.paginatedSpanArr[position] = count;
      }
    },

    // 计算需要合并的行（保留原方法以备用）
    getSpanArr (data) {
      this.spanArr = [];
      let position = 0;
      const brandMap = {};

      data.forEach(item => {
        if (brandMap[item.zjpp]) {
          brandMap[item.zjpp].push(item);
        } else {
          brandMap[item.zjpp] = [item];
        }
      });

      let currentBrand = '';
      let count = 0;

      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          currentBrand = item.zjpp;
          count = 1;
        } else if (item.zjpp === currentBrand) {
          this.spanArr.push(0);
          count++;

          if (index === data.length - 1) {
            this.spanArr[position] = count;
          }
        } else {
          this.spanArr[position] = count;
          position = index;
          this.spanArr.push(1);
          currentBrand = item.zjpp;
          count = 1;
        }
      });
    },

    // 单元格合并方法
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 只对第一列（设备品牌）进行合并处理，其他列不做任何合并
      if (columnIndex === 0) {
        const _row = this.paginatedSpanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col
        };
      }
      // 其他列返回默认值，确保正常显示
      return {
        rowspan: 1,
        colspan: 1
      };
    },

    // 分页大小改变
    handleSizeChange (val) {
      this.pageSize = val;
      this.currentPage = 1;
    },

    // 当前页改变
    handleCurrentChange (val) {
      this.currentPage = val;
    },

    calculateOfflineDuration(row) {
      if (row.zt === '0' && row.cjsj) {
        // 离线状态且有采集时间数据
        const currentTime = new Date().getTime();
        const lastHeartbeatTime = new Date(row.cjsj).getTime();

        // 如果采集时间有效
        if (!isNaN(lastHeartbeatTime)) {
          const duration = Math.floor((currentTime - lastHeartbeatTime) / 1000);

          if (duration > 0) {
            const days = Math.floor(duration / 86400);
            const hours = Math.floor((duration % 86400) / 3600);
            const minutes = Math.floor((duration % 3600) / 60);
            const seconds = duration % 60;

            let result = '';
            if (days > 0) {
              result += `${days}天`;
            }
            if (hours > 0) {
              result += `${hours}小时`;
            }
            if (minutes > 0) {
              result += `${minutes}分钟`;
            }
            if (seconds > 0 && days === 0) {
              result += `${seconds}秒`;
            }

            return result || '刚刚离线';
          }
        }

        return '离线时间未知';
      } else if (row.zt === '1') {
        // 在线状态
        return '设备在线';
      } else if (row.zt === '3') {
        // 未关联状态
        return '未关联';
      }

      return '状态未知';
    },

    applySorting(data) {
      if (!this.sortOrder) return data;

      return [...data].sort((a, b) => {
        const getDurationSeconds = (row) => {
          if (row.zt === '0' && row.cjsj) {
            const currentTime = new Date().getTime();
            const lastHeartbeatTime = new Date(row.cjsj).getTime();
            if (!isNaN(lastHeartbeatTime)) {
              return Math.floor((currentTime - lastHeartbeatTime) / 1000);
            }
          }
          // 在线设备或无时间数据的设备排序值为0
          return row.zt === '1' ? 0 : -1;
        };

        const aDuration = getDurationSeconds(a);
        const bDuration = getDurationSeconds(b);

        if (this.sortOrder === 'asc') {
          return aDuration - bDuration;
        } else if (this.sortOrder === 'desc') {
          return bDuration - aDuration;
        }
        return 0;
      });
    },

    applyFilters() {
      this.currentPage = 1;
      this.fetchData();
    },

    clearFilters() {
      this.filters = {
        zjpp: '',
        zjmc: '',
        azwz: ''
      };
      this.sortOrder = '';
      this.applyFilters();
    }
  },
  created () {
    this.fetchData();

    // 设置定时器，每30秒刷新一次离线时长显示
    this.refreshTimer = setInterval(() => {
      this.$forceUpdate();
    }, 30000);
  },
  destroyed () {
    // 清理定时器
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }
};
</script>

<style scoped>
.wxyg-table {
  background: transparent !important;
  position: relative;
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 580px; /* 增加最大高度以更好利用弹窗空间 */
}

.wxyg-status-message {
  padding: 10px 15px;
  margin-right: 5px;
  background: rgba(57,183,85,0.20);
  border: 1px solid rgba(57,183,85,1);
  color: #DCE8FF 100%;
  font-size: 16px;
  flex-shrink: 0; /* 防止收缩 */
}

.table-container {
  flex: 1;
  overflow-y: auto;
  min-height: 250px;
  max-height: 350px; /* 增加最大高度 */
}

.pagination-container {
  padding: 10px 0;
  display: flex;
  justify-content: center;
  background: transparent;
  flex-shrink: 0; /* 防止收缩 */
}

.wxyg-status-message.warning {
  background: rgba(249,1,1,0.20);
  border: 1px solid rgba(249,1,1,1);
}

.status-message {
  display: flex;
  align-items: left;
}

.status-message-text {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #DCE8FF;
  letter-spacing: 0;
  font-weight: 400;
}

.online {
  color: #11F155;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
}

.offline {
  color: #F90101;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
}

.unlinked {
  color: #f39c12;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
}

.error-message {
  color: #e74c3c;
  background-color: rgba(231, 76, 60, 0.2);
  border: 1px solid #e74c3c;
  border-radius: 4px;
  padding: 10px;
  margin-top: 15px;
}

/* 自定义空数据显示样式 */
.el-table__empty-text{
  display: none;
}

/* 添加合并单元格的样式 */
/deep/ .el-table__row .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 8px;
}

/* 合并的单元格居中显示 */
/deep/ .el-table .cell {
  text-align: center;
  line-height: 1.5;
}

/* 确保表格列有固定宽度，防止内容溢出 */
::v-deep .el-table th,
::v-deep .el-table td {
  padding: 8px 0;
  min-width: 100px;
}

/* 第一列（品牌列）的特殊样式 */
::v-deep .el-table th:first-child,
::v-deep .el-table td:first-child {
  min-width: 120px;
}

/* 确保每列内容不会相互覆盖 */
::v-deep .el-table .el-table__cell {
  padding: 0 8px;
  box-sizing: border-box;
}

/* 分页组件样式 */
::v-deep .el-pagination {
  color: #DCE8FF;
}

::v-deep .el-pagination .el-select .el-input input {
  background-color: rgba(51, 129, 231, 0.3);
  border-color: rgba(93, 174, 240, 0.5);
  color: #DCE8FF;
}

::v-deep .el-pagination .el-pager li {
  background-color: rgba(51, 129, 231, 0.3);
  color: #DCE8FF;
  border: 1px solid rgba(93, 174, 240, 0.3);
}

::v-deep .el-pagination .el-pager li.active {
  background-color: rgba(93, 174, 240, 0.8);
  color: #fff;
}

::v-deep .el-pagination .btn-prev,
::v-deep .el-pagination .btn-next {
  background-color: rgba(51, 129, 231, 0.3);
  color: #DCE8FF;
  border: 1px solid rgba(93, 174, 240, 0.3);
}

::v-deep .el-pagination .el-input__inner {
  background-color: rgba(51, 129, 231, 0.3);
  border-color: rgba(93, 174, 240, 0.5);
  color: #DCE8FF;
}

/* 表格透明化及边框颜色 */
::v-deep .el-table,
::v-deep .el-table__header-wrapper,
::v-deep .el-table__body-wrapper,
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
  background-color: transparent !important;
  border-color: rgba(93, 174, 240, 0.3) !important;
}

::v-deep .el-table th {
  background: rgba(51, 129, 231, 0.3) !important;
  font-weight: normal;
  position: sticky;
}

::v-deep .el-table--border {
  border-color: rgba(93, 174, 240, 0.3) !important;
}

::v-deep .el-table--border th,
::v-deep .el-table--border td {
  border-right-color: rgba(93, 174, 240, 0.3) !important;
}

/* 文字样式调整 */
::v-deep .el-table td,
::v-deep .el-table th {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #DCE8FF;
  letter-spacing: 0;
  font-weight: 400;
}

::v-deep .el-table::before,
::v-deep .el-table::after {
  background-color: rgba(93, 174, 240, 0.3) !important;
}

::v-deep .el-table--border::after,
::v-deep .el-table--border::before {
  display: none;
}

::v-deep .el-table__body-wrapper td:last-child {
  border-right-color: rgba(93, 174, 240, 0.3) !important;
}

::v-deep .el-table__body tr:last-child td {
  border-bottom-color: rgba(93, 174, 240, 0.3) !important;
}

/* 滚动条样式 */
.table-container::-webkit-scrollbar {
  width: 8px;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: rgba(48, 101, 199, 0.658) !important;
  border-radius: 1px;
}

.table-container::-webkit-scrollbar-track {
  background-color: rgba(18, 54, 95, 0.753);
  border-radius: 1px;
}

/* 离线时长列的特殊样式 */
::v-deep .el-table th:nth-child(4),
::v-deep .el-table td:nth-child(4) {
  min-width: 150px;
  max-width: 200px;
  font-weight: 500;
}

.filter-container {
  padding: 8px 10px;
  background: rgba(51, 129, 231, 0.3);
  border: 1px solid rgba(93, 174, 240, 0.3);
  border-radius: 4px;
  margin-bottom: 8px;
  flex-shrink: 0; /* 防止收缩 */
}

.filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.filter-item label {
  color: #DCE8FF;
  font-size: 12px;
  margin-right: 8px;
  white-space: nowrap;
  min-width: 60px;
}

/* 筛选输入框样式 */
::v-deep .filter-item .el-input__inner {
  background-color: rgba(18, 54, 95, 0.8);
  border-color: rgba(93, 174, 240, 0.5);
  color: #DCE8FF;
  font-size: 12px;
  height: 28px;
  width: 140px;
}

::v-deep .filter-item .el-input__inner::placeholder {
  color: rgba(220, 232, 255, 0.6);
}

::v-deep .filter-item .el-select {
  width: 140px;
}

::v-deep .filter-item .el-select .el-input__inner {
  background-color: rgba(18, 54, 95, 0.8);
  border-color: rgba(93, 174, 240, 0.5);
  color: #DCE8FF;
  width: 140px;
}

::v-deep .filter-item .el-button--mini {
  background-color: rgba(93, 174, 240, 0.8);
  border-color: rgba(93, 174, 240, 1);
  color: #fff;
  font-size: 12px;
  height: 28px;
  padding: 7px 10px;
  width: 80px;
}

/* 下拉选择框选项样式 */
::v-deep .el-select-dropdown {
  background-color: rgba(18, 54, 95, 0.95);
  border: 1px solid rgba(93, 174, 240, 0.5);
}

::v-deep .el-select-dropdown .el-option {
  background-color: transparent;
  color: #DCE8FF;
}

::v-deep .el-select-dropdown .el-option:hover {
  background-color: rgba(93, 174, 240, 0.3);
}

::v-deep .el-select-dropdown .el-option.selected {
  background-color: rgba(93, 174, 240, 0.8);
  color: #fff;
}
</style>
